/**
 * A Social Insurance Number (SIN) is a number issued in Canada to administer various government programs.
 *
 * See `https://en.wikipedia.org/wiki/Social_Insurance_Number` for more information.
 */

const SSN_EXPRESSION_CA = /^(?!666|000|9\d{2})\d{3}[- ]{0,1}(?!00)\d{3}[- ]{0,1}(?!0{4})\d{3}$/;

export default (securityNumber: string) => {
  // Should pass regex validation
  if (!SSN_EXPRESSION_CA.test(securityNumber)) {
    return false;
  }

  return true;
};
